// removed by extract-text-webpack-plugin
module.exports = {"Welcome":"Welcome__Welcome__xx7RD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Welcome/Welcome.css
// module id = 189
// module chunks = 1